import { defineStore } from "pinia";

export const appBarMobileStore = defineStore("appBarMobile", {
  state: () => ({
    showMenuIcon: false,
    showMenu: false,
  }),
});
